import { updateSearch } from 'bernie-core';
import { getDateObjectFromDateString, getIsoFormatDateFromDateString } from '../../helpers/date-helper';
export var getDateRangeFromUrl = function (queryParams, localDateFormat) {
  var startDateParam = queryParams.get('startDate');
  var endDateParam = queryParams.get('endDate');
  if (!startDateParam || !endDateParam) {
    return null;
  }
  var startDateObj = getDateObjectFromDateString(startDateParam, localDateFormat);
  var endDateObj = getDateObjectFromDateString(endDateParam, localDateFormat);
  if (!startDateObj || !endDateObj) {
    return null;
  }
  return {
    startDate: {
      year: startDateObj.getFullYear(),
      month: startDateObj.getMonth() + 1,
      day: startDateObj.getDate()
    },
    endDate: {
      year: endDateObj.getFullYear(),
      month: endDateObj.getMonth() + 1,
      day: endDateObj.getDate()
    }
  };
};
export var updateQueryForSearch = function (inputCriteria, localDateFormat, history, location) {
  var _a, _b, _c;
  if (!((_a = inputCriteria.activitySearchCriteria) === null || _a === void 0 ? void 0 : _a.primary.destination)) {
    return;
  }
  var _d = inputCriteria.activitySearchCriteria.primary,
    destination = _d.destination,
    dateRange = _d.dateRange;
  if (!destination || !dateRange) {
    return;
  }
  var updatedStartDate = "".concat(dateRange.startDate.year, "-").concat(dateRange.startDate.month, "-").concat(dateRange.startDate.day);
  var updatedEndDate = "".concat(dateRange.endDate.year, "-").concat(dateRange.endDate.month, "-").concat(dateRange.endDate.day);
  var updatedParams = {
    location: (_b = destination.regionName) !== null && _b !== void 0 ? _b : '',
    startDate: getIsoFormatDateFromDateString(updatedStartDate, localDateFormat),
    endDate: getIsoFormatDateFromDateString(updatedEndDate, localDateFormat),
    rid: (_c = destination.regionId) !== null && _c !== void 0 ? _c : '',
    pwaDialog: ''
  };
  updateSearch({
    history: history,
    location: location,
    newParams: updatedParams,
    newState: {},
    replace: false
  });
};